var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import $ from 'jquery';
import { throttle } from 'helpful-decorators';
import { getCurrentBreakpoint } from '../utils/breakpoint';
import { Breakpoint } from '../types/breakpoint';
const ELEMENT_SELECTOR = '.js__action-buttons';
const BUTTONS_WRAPPER_SELECTOR = '.js__action-buttons-wrapper';
export class ActionButtons {
    static init($root = $('body')) {
        const $actionButtons = $root.find(ELEMENT_SELECTOR);
        if (!$actionButtons.length) {
            return;
        }
        $(window).on('resize', () => {
            $actionButtons.each((index, element) => {
                const $element = $(element);
                this.actionsOnResize($element);
            });
        });
        this.displayActionsStyle($actionButtons);
    }
    static actionsOnResize($element) {
        this.displayActionsStyle($element);
    }
    static displayActionsStyle($element) {
        const currentBreakpoint = getCurrentBreakpoint();
        const $wrapper = $element.find(BUTTONS_WRAPPER_SELECTOR);
        const $wrapperParent = $wrapper.parent();
        $wrapper.removeClass('vertical');
        const wrapperWidth = $wrapper.width() || 0;
        const wrapperParentWidth = $wrapperParent.width() || 0;
        const displayActionsVertically = wrapperWidth >= wrapperParentWidth;
        $wrapper.toggleClass('vertical', currentBreakpoint < Breakpoint.xxl || displayActionsVertically);
    }
}
__decorate([
    throttle(300)
], ActionButtons, "actionsOnResize", null);
